function pxToRem(number: number) {
  const baseNumber = 16;
  return `${number / baseNumber}rem`;
}

export default pxToRem;
